import { Action, createReducer, on } from '@ngrx/store';
import * as AuthorizationActions from './authorization.actions';

export const AUTHORIZATION_KEY = 'authorization';

export interface State {
  permissions: string[];
  isLoading: boolean;
  isPermissionsLoaded: boolean;
}

export interface AuthorizationPartialState {
  readonly [AUTHORIZATION_KEY]: State;
}

export const initialState: State = {
  isPermissionsLoaded: false,
  permissions: [],
  isLoading: false
};

const authorizationReducer = createReducer(
  initialState,
  on(AuthorizationActions.loadPermissions, (state) => ({
    ...state,
    isLoading: true
  })),

  on(AuthorizationActions.loadPermissionsSuccess, (state, { permissions }) => ({
    ...state,
    isLoading: false,
    isPermissionsLoaded: true,
    permissions
  })),

  on(AuthorizationActions.loadPermissionsFailure, (state) => ({
    ...state,
    isLoading: false,
    isPermissionsLoaded: true,
    permissions: []
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return authorizationReducer(state, action);
}
